import { or } from 'tio-ui/utilities';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import type TasApplicationModel from 'tio-data/models/tas-application';
import type ProgressBuilder from '../../../services/progress-builder';
import { tracked } from '@glimmer/tracking';
import type EmployeeModel from 'tio-data/models/employee';
import type Owner from '@ember/owner';
import { PhCheck, PhWarning } from 'ember-phosphor-icons';

export interface ApproverDetailArgs {
  Args: {
    icon?: unknown;
    application: TasApplicationModel;
    iconBgColor?: string;
    stepToApprove: string;
  };
  Element: HTMLElement;
}

type FullName = {
  firstName?: string;
  lastName?: string;
};

type Approvers = {
  affirmedApprovers: (EmployeeModel | FullName | undefined)[];
  currentApprovers: (EmployeeModel | FullName | undefined)[];
  possibleApprovers: (EmployeeModel | FullName | undefined)[];
};

export class ApproverDetail extends Component<ApproverDetailArgs> {
  @service declare progressBuilder: ProgressBuilder;
  @tracked approvers: Approvers;

  constructor(owner: Owner, args: ApproverDetailArgs['Args']) {
    super(owner, args);
    this.approvers = this.progressBuilder.getApproversForStep(args.application, args.stepToApprove);
  }
  get hasAffirmedApprovers() {
    return this.approvers.affirmedApprovers.length > 0;
  }

  get hasCurrentApprovers() {
    return this.approvers.currentApprovers.length > 0;
  }

  <template>
    {{#if this.hasAffirmedApprovers}}
      <div class="flex items-start m-4">
        <div class="flex justify-center items-center w-12 h-12 mr-[10px] rounded-full bg-green-600">
          <PhCheck @size="32" class="text-white" />
        </div>
        <div class="mt-[5px] text-gray-400 mr-2">Approved by:</div>
        <div class="mt-[5px] text-gray-400">
          {{#each this.approvers.affirmedApprovers as |approver|}}
            <div>{{approver.firstName}} {{approver.lastName}}</div>
          {{/each}}
        </div>
      </div>
    {{/if}}

    {{#if this.hasCurrentApprovers}}
      <div class="flex items-start m-4">
        <div
          class="flex justify-center items-center w-12 h-12 mr-[10px] rounded-full
            {{or @iconBgColor 'bg-gray-400'}}"
        >
          <div class="h-6 text-white">
            {{#if @icon}}
              <@icon @size="16" />
            {{else}}
              <PhWarning @size="16" />
            {{/if}}
          </div>
        </div>
        <div class="mt-[5px] text-gray-400 mr-2">Approvers:</div>
        <div class="mt-[5px] text-gray-400">
          {{#each this.approvers.currentApprovers as |approver|}}
            <div>{{approver.firstName}} {{approver.lastName}}</div>
          {{/each}}
        </div>
      </div>
    {{/if}}
  </template>
}
